import { render, staticRenderFns } from "./AnggotaSelect.vue?vue&type=template&id=487491da&scoped=true"
import script from "./AnggotaSelect.vue?vue&type=script&lang=js"
export * from "./AnggotaSelect.vue?vue&type=script&lang=js"
import style0 from "./AnggotaSelect.vue?vue&type=style&index=0&id=487491da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487491da",
  null
  
)

export default component.exports